export enum CardColor {
    blue = 'blue',
    pink = 'pink',
    green = 'green',
    red = 'red',
}

export enum CardColorNumber {
    blue = 1,
    pink = 2,
    green = 3,
    red = 4,
}

export enum Animals {
    cat = 'cat',
    dog = 'dog',
    other = 'other',
    notAnAnimal = 'notAnAnimal',
}
